import { Link } from "react-router-dom";
// import styles from "../../404.module.css";
const PageNotFound = () => {
  return (
    <div className={"body_container"}>
      {/* <div style={{ padding: "100px 20px" }}>
          <h1>404 - Page Not Found</h1>
          <Link href="/" legacyBehavior>
          Go back home
          </Link>
        </div> */}
      <div className={"main_container"}>
        <div className="404gif">
          <div className={"gif_container"}>
            <img
              src="/img/404.gif"
              className={"gif"}
              layout="fill"
              alt="404 gif"
            />
          </div>
        </div>
        <div className="z-50 boldText">
          <h1 className={"head_1"}>It’s Not You!</h1>
          <h1 className={"head_2"}>It’s us who failed to load page!</h1>
          <h1 className={"head_3"}>
            Here are some helpful links instead:
          </h1>
        </div>
        <div className="use_full_links flex align-middle gap-y-[18px]	 gap-x-[30px] mt-[20px] flex-wrap justify-center">
          <Link to={"/"} className={"links"}>
            Home
          </Link>
        </div>
      </div>
    </div>
  );
};
export default PageNotFound;
